import { WorkCom } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { WorkcomParameters } from '../../manager/workflow/workflow.engine';
import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { entity, field, IVo } from '../entity-maps';
import { WizConstants } from '../../model/constants';

/**
 * VO représentant un WorkCom de mesure
 */
@entity('wizeoo.allkeyme.workflow.message.WorkCom', 'VISION')
export class WorkComVO implements IVo {
  

  
  constructor(model: Model, pSource?: WorkCom) {
    if (pSource) {
      this._source = pSource;
    } else {
        this._source = new WorkCom();
        this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
    }
    this._model = model; 
  }

  protected _model: Model = null;
  protected get model(): Model {
    return this._model as Model;
  }
  protected set model(value: Model) {
      this._model = value;
  }
  


  /** L'objet source provenant du back */
  protected _source: WorkCom;

  public get source(): WorkCom {
      return this._source;
  }
  public set source(value: WorkCom) {
      this._source = value;
  }

    // code domaine (root), technique
    public get domain(): string {
        return this._source.domain;
    }
    public set domain(value: string) {
        this._source.domain = value;
    }

    public get businessUnitCode(): string {
        // code de la BU
        return this._source.businessUnitCode;
    }
    public set businessUnitCode(value: string) {
        this._source.businessUnitCode = value;
    }

    // vision (* possible pour les FDV)
    public get vision(): string {
        return this._source.vision;
    }
    public set vision(value: string) {
        this._source.vision = value;
    }

  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu des lines
  public get maintenanceFlag(): string {
    return this.source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this.source.maintenanceFlag = value;
  }


  @field('string')
  public set shortCode(value: string) {
    this.source.shortCode = value;
  }
  public get shortCode(): string {
    return this.source.shortCode;
  }

  /** type de donnée du parent : BL, FDV ou rien (*) */
  @field('string')
  public set parentKind(value: string) {
    this.source.parentKind = value;
  }
  public get parentKind(): string {
    return this.source.parentKind;
  }

  /**
   * clé unique du parent (dans sa vision, * pour les FDV)
   */
  @field('string')
  public set parentKey(value: string) {
    this.source.parentKey = value;
  }
  public get parentKey(): string {
    return this.source.parentKey;
  }

  // Id technique
  public get id(): number {
    return this.source.id;
  }
  public set id(value: number) {
    this.source.id = value;
  }

  // UID technique
  public get uid(): string {
    return this.source.uid;
  }
  public set uid(value: string) {
    this.source.uid = value;
  }

  // clé d'unicité "métier"
  @field('string')
  public get naturalUID(): string {
    return this.source.naturalUID;
  }
  public set naturalUID(value: string) {
    this.source.naturalUID = value;
  }

  public get version(): number {
    // technique
    return this.source.version;
  }
  public set version(value: number) {
    this.source.version = value;
  }

  // objet du message
  @field('string')
  public get obj(): string {
    return this.source.obj;
  }
  public set obj(value: string) {
    this.source.obj = value;
  }

  // détail du message
  @field('string')
  public get comment(): string {
    return this.source.comment;
  }
  public set comment(value: string) {
    this.source.comment = value;
  }

  // paramètres avancés
  @field('string')
  public get params(): WorkcomParameters {
    return this.source.params;
  }
  public set params(value: WorkcomParameters) {
    this.source.params = value;
  }

  public set createTime(createTime: number) {
      this._source.createTime = createTime;
  }
  public get createTime(): number {
      return this._source.createTime;
  }

  public set createBy(createBy: string) {
      this._source.createBy = createBy;
  }
  public get createBy(): string {
      return this._source.createBy;
  }

  public get operation(): string {
    return this.source.operation;
  }
  public set operation(value: string) {
    this.source.operation = value;
  }


  /* ################################################
                    Accesseurs composites
  ################################################ */

  /** Le WorkCom est-il persisté ? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this.source.id > 0;
  }

  // refcode pour les EMs
  public get refCode(): string {
    return [this.domain, this.businessUnitCode, this.vision].join(WizConstants.KEY_SEPARATOR);
  }


  // détecteur de chargement effectif
  public loaded: boolean = false;

}
